import { get,} from "services/BaseClient/Client"
import headers from "services/BaseClient/Headers.json";
import { DataResponse } from "services/BaseClient/BaseResponseModel";
import endpoints from "./EndPoints";



export const getNewsDetails = async (newsId:string): Promise<DataResponse<any>> => {

    const url = `${endpoints.getNewsDetails}/${newsId}`;
    const config = headers.content_type.application_json;
    return get<DataResponse<any>>(url, config);
  };

 